module.exports = __webpack_public_path__ + "cement/img/蒙版组 19@2x.866300b2.png";